@keyframes global-player-color-pulse {
  0% {
    color: var(--tuna-palette-secondary-main);
  }
  50% {
    color: var(--tuna-palette-primary-main);
  }
  100% {
    color: var(--tuna-palette-secondary-main);
  }
}

.global-player-pulse {
  animation: global-player-color-pulse 2s ease infinite;
}

.playerButton {
  color: inherit;
}
